import {
  AuthorLayout,
  HoverBorder,
  StyledDepartment,
  StyledImg,
  StyledName,
} from '@/components/Approval/RightContainer/ApprovalContent/styles';
import AuthorTooltip from '@/components/Approval/RightContainer/ApprovalContent/AuthorTooltip';
import { imgUrlChk } from '@/utils/function';
import { Box } from '@mui/material';
import Skeleton from '@/components/@IntranetLibrary/Skeleton';
import React, { useState } from 'react';
import { Author } from '@/types/api';
import { useProfileCardModal } from '@/hooks/global-tools';

type AuthorInfoProps = {
  author: Author;
  onClick?: (author: Author) => void;
};

const AuthorInfo = ({ author, onClick }: AuthorInfoProps) => {
  const [profileImgError, setProfileImgError] = useState(false);
  const reduceMode = window.innerWidth < 1440;
  const profileCardModal = useProfileCardModal();

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    profileCardModal.open(author.passportId, false);
    onClick?.(author);
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <Box onClick={handleClick}>
      <AuthorLayout reduceMode={reduceMode}>
        {reduceMode && (
          <AuthorTooltip
            name={author.name}
            placeName={author.placeName}
            departmentName={author.departmentName}
          >
            <HoverBorder />
          </AuthorTooltip>
        )}
        {author.profileImageUrl ? (
          <StyledImg
            profileImgError={profileImgError}
            src={
              profileImgError
                ? '/images/dummy/default-profile.svg'
                : imgUrlChk(author.profileImageUrl)
            }
            alt={`${author.passportId}-image`}
            onError={() => setProfileImgError(true)}
          />
        ) : (
          <Skeleton variant={'circle'} width={32} height={32} />
        )}
        {!reduceMode && (
          <div
            style={{
              textAlign: 'start',
              marginLeft: '8px',
              width: 'calc(100% - 40px)',
            }}
          >
            <StyledName>{`${author.name} ${author.positionName}`}</StyledName>
            <StyledDepartment>{`${author.placeName} ${author.departmentName}`}</StyledDepartment>
          </div>
        )}
      </AuthorLayout>
    </Box>
  );
};

export default AuthorInfo;
